module.exports = __webpack_public_path__ + "img/info_icon_dark.53cd419d.svg";